import {
  DEFAULT_THEME,
  LEGACY_THEME_STORAGE_KEY,
  THEME_STORAGE_KEY,
} from '@/lib/theme-config';

/** Script bloqueante: aplica dark/light antes del primer paint (evita flash blanco). */
export function ThemeScript() {
  const script = `
(function () {
  var key = ${JSON.stringify(THEME_STORAGE_KEY)};
  var legacyKey = ${JSON.stringify(LEGACY_THEME_STORAGE_KEY)};
  var fallback = ${JSON.stringify(DEFAULT_THEME)};
  try {
    var stored = localStorage.getItem(key) || localStorage.getItem(legacyKey) || fallback;
    var resolved = stored;
    if (stored === 'system') {
      resolved = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    var root = document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(resolved);
  } catch (e) {
    document.documentElement.classList.add(fallback);
  }
})();
`;

  return <script dangerouslySetInnerHTML={{ __html: script }} />;
}
